import { CommonModule } from '@angular/common'
import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ExploreService } from 'src/app/service/explore/explore.service'
import { DdcAppstoreBtnSmallComponent } from 'src/app/shared/ddc/ddc-appstore-btn-small/ddc-appstore-btn-small.component'
import { DdcContentCardComponent } from 'src/app/shared/ddc/ddc-content-card/ddc-content-card.component'
import { DdcElemChooserOneComponent } from 'src/app/shared/ddc/ddc-elem-chooser-one/ddc-elem-chooser-one.component'
import { Dictionary } from 'src/app/shared/models/main/dictionary'

interface CategoryConfig {
  title: string
  icon: string
  subtitle: string
}

const CATEGORY_MAP: Record<string, CategoryConfig> = {
  travel: { title: 'Travel', icon: 'flight', subtitle: 'Explore the world with confidence' },
  academy: {
    title: 'Academy',
    icon: 'school',
    subtitle: 'Learn and grow your skills based on selected topic',
  },
  love: { title: 'Love', icon: 'favorite', subtitle: 'Find your perfect match' },
  'driving-license': {
    title: 'Driver License',
    icon: 'directions_car',
    subtitle: 'Get ready for the road',
  },
}

@Component({
  selector: 'ddc-store-category',
  templateUrl: './ddc-store-category.component.html',
  styleUrls: ['./ddc-store-category.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [
    CommonModule,
    AngularMaterialsModules,
    DdcContentCardComponent,
    DdcElemChooserOneComponent,
    DdcAppstoreBtnSmallComponent,
  ],
})
export class DdcStoreCategoryComponent implements OnInit {
  category = ''
  config: CategoryConfig = { title: '', icon: '', subtitle: '' }

  daydicTopics = [
    { id: 1, label: 'Pharmacy' },
    { id: 2, label: 'Electrical Engineering' },
    { id: 3, label: 'Computer Science' },
    { id: 4, label: 'Medicine' },
    { id: 5, label: 'Law' },
    { id: 6, label: 'Business Administration' },
    { id: 7, label: 'Psychology' },
    { id: 8, label: 'Biology' },
    { id: 9, label: 'Chemistry' },
    { id: 10, label: 'Physics' },
    { id: 11, label: 'Mathematics' },
    { id: 12, label: 'History' },
    { id: 13, label: 'Literature' },
    { id: 14, label: 'Art' },
    { id: 15, label: 'Music' },
    { id: 16, label: 'Economics' },
    { id: 17, label: 'Political Science' },
    { id: 18, label: 'Sociology' },
    { id: 19, label: 'Engineering' },
    { id: 20, label: 'Nursing' },
  ]

  selectedTopic: string | null = null
  dictionaries: Dictionary[] = []
  loading = false
  loadingMore = false
  hasMore = true
  page = 1
  pageSize = 10

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private exploreService: ExploreService,
  ) {}

  ngOnInit(): void {
    this.category = this.route.snapshot.paramMap.get('category') || ''
    this.config = CATEGORY_MAP[this.category] || {
      title: 'Category',
      icon: 'category',
      subtitle: '',
    }

    if (this.config.title === 'Academy') {
      // Optionally, you can pre-load some default topic dictionaries here
    } else if (this.config.title === 'Love') {
      this.onTopicChange('love')
    } else if (this.config.title === 'Driver License') {
      this.onTopicChange('driving-license')
    }
  }

  onTopicChange(topic: string): void {
    if (!topic) {
      this.dictionaries = []
      this.hasMore = true
      this.page = 1
      return
    }
    this.loading = true
    this.page = 1
    this.hasMore = true
    if (this.config.title === 'Academy') {
      this.exploreService
        .get_academy_dictionaries_by_topic(topic, this.page, this.pageSize)
        .subscribe({
          next: res => {
            this.dictionaries = res.results || []
            this.hasMore = !!res.next
            this.loading = false
          },
          error: () => {
            this.dictionaries = []
            this.hasMore = false
            this.loading = false
          },
        })
    } else if (this.config.title === 'Love') {
      this.exploreService.get_love_dictionaries().subscribe({
        next: res => {
          this.dictionaries = res.results || []
          this.hasMore = false
          this.loading = false
        },
        error: () => {
          this.dictionaries = []
          this.hasMore = false
          this.loading = false
        },
      })
    } else if (this.config.title === 'Driver License') {
      this.exploreService.get_driving_license_dictionaries().subscribe({
        next: res => {
          this.dictionaries = res.results || []
          this.hasMore = false
          this.loading = false
        },
        error: () => {
          this.dictionaries = []
          this.hasMore = false
          this.loading = false
        },
      })
    }
  }

  loadMore(): void {
    if (this.loadingMore || !this.hasMore || !this.selectedTopic) return
    this.loadingMore = true
    this.page += 1
    if (this.config.title === 'Academy') {
      this.exploreService
        .get_academy_dictionaries_by_topic(this.selectedTopic, this.page, this.pageSize)
        .subscribe({
          next: res => {
            this.dictionaries = this.dictionaries.concat(res.results || [])
            this.hasMore = !!res.next
            this.loadingMore = false
          },
          error: () => {
            this.hasMore = false
            this.loadingMore = false
          },
        })
    }
  }

  onScroll(event: any): void {
    const target = event.target
    if (target.scrollHeight - target.scrollTop - target.clientHeight < 100) {
      this.loadMore()
    }
  }

  onCardClick(dictionary: Dictionary): void {
    // Optionally handle card click
  }

  goBack(): void {
    this.router.navigate(['/store'])
  }

  updateSelectedTopic(topic: any): void {
    console.log('Selected topic:', topic)
    this.selectedTopic = topic[0].label
    this.onTopicChange(this.selectedTopic)
  }
}
